import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00286 = new TileLayer({
  title: 'Máscara 20021107',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20021107l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00286.setVisible(false);

const layer00285 = new TileLayer({
  title: 'Máscara 20030110',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030110l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00285.setVisible(false);

const layer00284 = new TileLayer({
  title: 'Máscara 20030211',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030211l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00284.setVisible(false);

const layer00283 = new TileLayer({
  title: 'Máscara 20030416',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030416l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00283.setVisible(false);

const layer00282 = new TileLayer({
  title: 'Máscara 20030518',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030518l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00282.setVisible(false);

const layer00281 = new TileLayer({
  title: 'Máscara 20030627',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030627l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00281.setVisible(false);

const layer00280 = new TileLayer({
  title: 'Máscara 20030814',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030814l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00280.setVisible(false);
 
const layer00279 = new TileLayer({
  title: 'Máscara 20030830',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20030830l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00279.setVisible(false);

export const grupoCapa01_19 = new LayerGroup({
  title: 'Ciclo Hidrológico 2002-2003',
  fold: 'close',
  layers: [layer00279, layer00280, layer00281, layer00282, layer00283, layer00284, layer00285, layer00286]
});